import React, { PureComponent } from 'react';
import createReactContext from 'create-react-context';
import SnackbarContainer from '../SnackbarContainer';
export const SnackbarContext = createReactContext('snackbar');
export class SnackbarProvider extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            snackbar: null,
        };
    }
    render() {
        return (<SnackbarContext.Provider value={this.state}>
        {this.props.children}
        <SnackbarContainer ref={el => {
            if (!this.state.snackbar && el) {
                this.setState({
                    snackbar: el,
                });
            }
        }}/>
      </SnackbarContext.Provider>);
    }
}
